module.exports = __webpack_public_path__ + "static/media/sopt16ru.61a81de3.pdf";